<script setup lang="ts">
import { computed, unref } from "vue";
import { useFormattedCurrency } from "~/composables/useFormattedCurrency";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import FormattedDate from "~/templates/elements/FormattedDate.vue";

export interface ContractExchangeboxInformationProps {
  contract: object;
  plan?: object;
}

const { contract } = defineProps<ContractExchangeboxInformationProps>();

const lastChangedDate = computed(() => {
  const webContractOrders = contract?.webContractOrders ?? [];

  webContractOrders.sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);

    // Sort by latest date in descending order
    return dateB - dateA;
  });

  return webContractOrders[0]?.order?.orderDate;
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <CommonLabel class="font-medium" path="BWF/shop/account/subscriptions/contract/cylinderLabel" />
    <div>
      <CommonLabel path="BWF/shop/account/subscriptions/contract/cylinderAtHome" tag="div" />
      <CommonLabel
        path="BWF/shop/account/subscriptions/contract/cylindersAtHomeInformation"
        :placeholder="{
          amount: contract?.deposit?.depositItemQuantity,
          label: plan?.product?.customFields?.['contract_deposit_line_item_label'],
          price: unref(
            useFormattedCurrency(contract?.deposit?.depositItemUnitPrice).formattedValue,
          ),
        }"
        tag="div"
      />
    </div>
    <div>
      <CommonLabel path="BWF/shop/account/subscriptions/contract/contractDeposit" tag="div" />
      <SharedPrice :value="contract?.deposit?.contractTotalDepositAmount" />
    </div>
    <div>
      <CommonLabel
        class="font-medium"
        path="BWF/shop/account/subscriptions/contract/lastChangeLabel"
        tag="div"
      />
      <FormattedDate v-if="lastChangedDate" :date="lastChangedDate" />
    </div>
  </div>
</template>
